var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgForeignerStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 22.713,
    cy: 32.096,
    r: 1.555
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M28.034 39.82H8.814c-2.39 0-4.34-1.94-4.34-4.34V7.17c0-2.39 1.95-4.34 4.34-4.34h21.15c2.4 0 4.34 1.95 4.34 4.34v16.09"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.621 16.841a9.14 9.14 0 01-1.43 4.931 9.214 9.214 0 01-7.795 4.295c-.48 0-.95-.038-1.411-.105a9.233 9.233 0 01-6.389-4.19 9.15 9.15 0 01-1.43-4.931c0-1.891.565-3.643 1.539-5.102a9.227 9.227 0 016.28-4.023 9.793 9.793 0 011.411-.105 9.22 9.22 0 017.686 4.128 9.146 9.146 0 011.539 5.102zM28.624 16.839H10.169M19.396 26.066c-8.91-9.128 0-18.455 0-18.455M19.396 26.066c8.91-9.128 0-18.455 0-18.455"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M10.493 32.096h6.923"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M28.793 31.973l3.331 3.515 5.922-6.785"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgForeignerStart);
export default __webpack_public_path__ + "static/media/foreignerStart.295066e3fd096ecac025e8665ac9ec69.svg";
export { ForwardRef as ReactComponent };